import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";

export const duplicateTNS = async (
    tnsId : string, 
    token : string | undefined, 
    setOpenModal : Function,
    dispatch : Function
) => {
    try {
        const response = await axios.post(`${urlAPI}/forecast/tns/duplicate/${tnsId}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );        
        setOpenModal(false);
        dispatch(showSnackbar("TNS dupliqué avec succès.", "success"));
      } catch (error: any) {
        if (error.response) {
          console.error("Erreur API :", error.response.data);
          console.error("Statut :", error.response.status);
        } else if (error.request) {
          console.error("Erreur de requête :", error.request);
        } else {
          console.error("Erreur :", error.message);
        }
  
        dispatch(showSnackbar("Erreur lors de la duplication.", "error"));
    }
}